import { DeraQuestionType, DeraSubsectionLookup } from './dera-questions.interface';

// See dera-background.ts for the question/subsection format.
export const DeraEmploymentSubsections: { [key: string]: DeraSubsectionLookup } = {
  employmentVolunteerHistory: {
    displayValue: 'Employment / Volunteer History',
    questions: {
      currentEmploymentStatus: {
        displayValue: 'Current employment status',
        type: DeraQuestionType.Radio,
        required: true,
        requiredMessage: 'Please select an option',
        options: {
          employed: { displayValue: 'Currently employed' },
          notEmployed: { displayValue: 'Not currently employed' },
        },
      },
    },
  },
  workHistoryDetails: {
    displayValue: 'Work history details',
    optional: true,
    questions: {
      workHistory: {
        displayValue: '',
        type: DeraQuestionType.Custom,
      },
      workHistoryComment: {
        displayValue: 'Comments:',
        type: DeraQuestionType.Comment,
        placeholder: 'Add any relevant details regarding the person’s work history',
      },
      employmentInsurance: {
        displayValue: 'Employment Insurance',
        type: DeraQuestionType.Radio,
        required: true,
        requiredMessage: 'Please select an option',
        options: {
          appliedActiveClaim: { displayValue: 'Has applied for EI in the past 12 months, has an active claim' },
          appliedNoActiveClaim: {
            displayValue: 'Has applied for EI in the past 12 months, does not have an active claim',
          },
          notApplied: { displayValue: 'Has not applied for EI in the past 12 months' },
        },
        comment: { placeholder: 'Add any relevant details regarding the person’s EI status' },
      },
      dailyWeeklyRoutine: {
        displayValue: 'Daily / weekly routine',
        type: DeraQuestionType.Comment,
        placeholder:
          'Describe the main activities that comprise a typical day or week, including any volunteer or community activities',
      },
      enjoyableAspects: {
        displayValue: 'Enjoyable aspects of work, volunteer, or training activities',
        type: DeraQuestionType.Comment,
        placeholder:
          'Describe aspects of previous or current jobs, volunteer activities and/or training the person enjoyed, e.g., enjoy interacting with new people while serving food at community dinners',
      },
      strengthsAndSkills: {
        displayValue: 'Strengths and skills for work',
        type: DeraQuestionType.Comment,
        placeholder:
          'List skills demonstrated in previous or current jobs, volunteer activities and/or training, e.g., strong interpersonal skills demonstrated by volunteer experience at community dinner',
      },
    },
  },
  employmentInterestsGoals: {
    displayValue: 'Employment Interests and Goals',
    questions: {},
  },
  employmentSearchSkills: {
    displayValue: 'Employment Search Skills',
    questions: {},
  },
};
